/* =====================================================================
   Variant Gallery Swap  (v2 — hide-Berlin-and-build-our-own)
   ---------------------------------------------------------------------
   The v1 approach (hot-swapping images inside Berlin's <slider-element>)
   broke because Berlin's slider caches slide count, wires up thumbnail
   click handlers, and doesn't reinitialize when the media list changes.
   The result: main slider blank, orphan thumbnail row, no click-to-
   preview.

   v2 approach: HIDE Berlin's entire `.product__media-container` and
   render an independent gallery in a sibling div. Because our gallery
   is self-contained, we control the main image, the thumbnail row,
   and the click-to-preview behaviour — no interop with Berlin.

   On variant change (URL ?variant= update, variant:change event,
   pushState), we rebuild our gallery from scratch. Berlin's picker
   still updates the URL; we react to that.

   Gated on the presence of the <script id="hb-variant-galleries">
   blob emitted by variant-gallery-data.liquid. Silent no-op otherwise.
   ===================================================================== */
(function () {
  "use strict";

  var galleriesEl = document.getElementById("hb-variant-galleries");
  if (!galleriesEl) return;

  var data;
  try {
    data = JSON.parse(galleriesEl.textContent);
  } catch (err) {
    return;
  }
  if (!data || typeof data !== "object") return;

  var BERLIN_CONTAINER_SELECTOR = ".product__media-container";
  var OUR_GALLERY_ID = "hb-variant-gallery";

  function currentVariantId() {
    try {
      var url = new URL(window.location.href);
      var vid = url.searchParams.get("variant");
      return vid ? String(vid) : null;
    } catch (e) {
      return null;
    }
  }

  function firstVariantIdWithImages() {
    for (var k in data) {
      if (data[k] && data[k].length) return k;
    }
    return null;
  }

  function imagesFor(variantId) {
    if (variantId && data[variantId] && data[variantId].length) {
      return data[variantId];
    }
    var fallback = firstVariantIdWithImages();
    return fallback ? data[fallback] : null;
  }

  // Inject a scoped stylesheet once. Keeps the gallery visually
  // aligned with Berlin's original layout: main image on the right,
  // thumbnail column on the left on desktop; thumbnails below on
  // mobile.
  function injectStyle() {
    if (document.getElementById("hb-variant-gallery-style")) return;
    var s = document.createElement("style");
    s.id = "hb-variant-gallery-style";
    s.textContent = [
      "#hb-variant-gallery{display:flex;flex-direction:column-reverse;gap:1rem;width:100%;}",
      "@media(min-width:1024px){#hb-variant-gallery{flex-direction:row;align-items:flex-start;}}",
      "#hb-variant-gallery .hb-thumbs{display:flex;flex-direction:row;gap:.5rem;overflow-x:auto;flex-wrap:nowrap;}",
      "@media(min-width:1024px){#hb-variant-gallery .hb-thumbs{flex-direction:column;overflow-y:auto;overflow-x:visible;max-height:600px;flex-wrap:nowrap;}}",
      "#hb-variant-gallery .hb-thumb{flex:0 0 auto;width:80px;height:80px;padding:0;border:2px solid transparent;background:#fff;cursor:pointer;overflow:hidden;border-radius:4px;}",
      "#hb-variant-gallery .hb-thumb.is-active{border-color:#111;}",
      "#hb-variant-gallery .hb-thumb img{width:100%;height:100%;object-fit:cover;display:block;}",
      "#hb-variant-gallery .hb-main{flex:1 1 auto;width:100%;position:relative;background:#f5f5f5;border-radius:8px;overflow:hidden;}",
      "#hb-variant-gallery .hb-main img{width:100%;height:auto;display:block;aspect-ratio:1/1;object-fit:cover;}"
    ].join("");
    document.head.appendChild(s);
  }

  var _hbGallery = null;   // our root element
  var _hbMainImg = null;   // main image element inside gallery
  var _hbThumbsEl = null;  // thumbnails container

  function ensureGalleryMounted() {
    var berlinContainer = document.querySelector(BERLIN_CONTAINER_SELECTOR);
    if (!berlinContainer) return null;

    _hbGallery = document.getElementById(OUR_GALLERY_ID);
    if (_hbGallery) return _hbGallery;

    // Build gallery skeleton
    _hbGallery = document.createElement("div");
    _hbGallery.id = OUR_GALLERY_ID;

    _hbThumbsEl = document.createElement("div");
    _hbThumbsEl.className = "hb-thumbs";

    var mainWrap = document.createElement("div");
    mainWrap.className = "hb-main";
    _hbMainImg = document.createElement("img");
    _hbMainImg.setAttribute("alt", "");
    _hbMainImg.setAttribute("loading", "eager");
    mainWrap.appendChild(_hbMainImg);

    _hbGallery.appendChild(_hbThumbsEl);
    _hbGallery.appendChild(mainWrap);

    // Insert our gallery just before Berlin's container, then hide
    // Berlin's container entirely so its slider + thumbnails stop
    // rendering. Using inline style so it beats theme CSS.
    berlinContainer.parentNode.insertBefore(_hbGallery, berlinContainer);
    berlinContainer.style.display = "none";

    injectStyle();
    return _hbGallery;
  }

  function setMainImage(img) {
    if (!img || !_hbMainImg) return;
    _hbMainImg.setAttribute("src", img.url);
    _hbMainImg.setAttribute("alt", img.alt || "");
    if (img.width) _hbMainImg.setAttribute("width", img.width);
    if (img.height) _hbMainImg.setAttribute("height", img.height);
  }

  function buildThumbButton(img, index) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "hb-thumb";
    btn.setAttribute("data-index", String(index));
    btn.setAttribute("aria-label", img.alt || "View image " + (index + 1));
    var el = document.createElement("img");
    el.setAttribute("src", img.url);
    el.setAttribute("alt", img.alt || "");
    el.setAttribute("loading", "lazy");
    btn.appendChild(el);
    btn.addEventListener("click", function () {
      // Move active class to this thumb + swap main image.
      var thumbs = _hbThumbsEl.querySelectorAll(".hb-thumb");
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.remove("is-active");
      }
      btn.classList.add("is-active");
      setMainImage(img);
    });
    return btn;
  }

  var _lastVariantSwapped = null;

  function swap(variantId) {
    var images = imagesFor(variantId);
    if (!images || !images.length) return;
    if (variantId === _lastVariantSwapped) return;
    _lastVariantSwapped = variantId;

    if (!ensureGalleryMounted()) return;

    // Populate main image with the first image in the gallery.
    setMainImage(images[0]);

    // Rebuild thumbnails.
    while (_hbThumbsEl.firstChild) _hbThumbsEl.removeChild(_hbThumbsEl.firstChild);
    images.forEach(function (img, i) {
      var btn = buildThumbButton(img, i);
      if (i === 0) btn.classList.add("is-active");
      _hbThumbsEl.appendChild(btn);
    });
  }

  // ---- Trigger wiring --------------------------------------------

  var _lastUrl = window.location.href;
  setInterval(function () {
    if (window.location.href !== _lastUrl) {
      _lastUrl = window.location.href;
      swap(currentVariantId());
    }
  }, 250);

  document.addEventListener("variant:change", function () {
    swap(currentVariantId());
  });

  var _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    swap(currentVariantId());
  };
  window.addEventListener("popstate", function () {
    swap(currentVariantId());
  });

  function initialRun() {
    swap(currentVariantId());
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialRun);
  } else {
    initialRun();
  }
})();